import LegacyCertificatePage from '../LegacyCertificatePage';

const FinanceTrainingCertificate = () => <LegacyCertificatePage program="Finance Training" backTo="/finance-training" />;

export default FinanceTrainingCertificate;
